import z from 'zod';
import { request } from '../../../utils/request';
import { walletKycDirectorSchema } from '../../../schemas/wallet-kyc-schema';
export default function addDirector(props: {
  corporateId: number;
  director: z.infer<typeof walletKycDirectorSchema>;
  authToken: string;
}): Promise<{
  success: boolean;
  message: string;
  director_index: number;
}> {
  return request({
    url: `/sterling/kyc/directors`,
    method: 'POST',
    formData: { corporate_id: props.corporateId, director: props.director },
    headers: { Authorization: `Bearer ${props.authToken}` },
  });
}
